// extracted by mini-css-extract-plugin
export var banner = "_hd-0";
export var closeButton = "_hd-2";
export var greenCheckmark = "_hd-3";
export var hereLink = "_hd-4";
export var titleIcon = "_hd-1";